import React, { useEffect } from "react";
import styled from "styled-components";
import BlogPage from "components/Page/BlogPage";
import Page from "components/Page/Page";
import PortfolioLayout from "components/PortfolioLayout/PortfolioLayout";
import projects from "data/projects.json";

const CaseStudyPane = styled.div`
  width: 100%;
  min-width: 0;
`;

export default function ProjectPage({ match }) {
  const { slug } = match.params;
  const project = projects.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <Page currentPage={slug}>
      <PortfolioLayout compact>
        <CaseStudyPane>
          <BlogPage
            embedded
            markdownFile={`projects/${slug}.md`}
            currentPage={slug}
            callout={project?.description}
            tags={project?.tags}
            company={project?.company}
            date={project?.date}
          />
        </CaseStudyPane>
      </PortfolioLayout>
    </Page>
  );
}
